import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import HelpCenterItem from "../../components/helpCenter/HelpCenterItem";

const HelpHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('مركز المساعدة');
    const [userData, setUserData] = useState(null);
    const pageTitle = {title: 'مركز المساعدة', subTitle: 'يمكنك متابعة الاسئلة الشائعة واالتواصل مع الدعم'};


    const handleGetUser = (user) => {
        setUserData(user);
    }

    const helpCenterData = [
      {name: 'طلبات الصيانة',
        questions: [
          {
            question: 'كيف أقدم طلب صيانة جديد؟',
            answer: 'لتقديم طلب صيانة، ادخل على "طلبات الصيانة"، اختر الخدمة والوحدة، حدّد الوقت والتاريخ، ثم راجع الطلب وأرسله.'
          },
          {
            question: 'هل يمكنني متابعة حالة الطلب بعد الإرسال؟',
            answer: 'نعم، يمكنك متابعة حالة كل طلب من خلال صفحة "طلبات الصيانة" ومعرفة إذا تم قبول الطلب أو جاري تعيين فني أو تم إنهاؤه.'
          },
          {
            question: 'كيف أعدل أو ألغي طلب صيانة؟',
            answer: 'إذا لم يتم تعيين فني بعد، يمكنك التعديل أو الإلغاء مباشرة من صفحة الطلبات. أما إذا بدأ التنفيذ، يرجى التواصل مع الدعم.'
          },
          {
            question: 'هل يوجد وقت محدد لتنفيذ الطلب؟',
            answer: 'نعم، عند تقديم الطلب يمكنك تحديد الوقت المناسب لك، وسيقوم الفريق بالتأكيد حسب توفر الفنيين.'
          }
        ]
      },
      {name: 'طلبات الدفع',
        questions: [
          {
            question: 'كيف يمكنني معرفة إذا كان هناك أمر دفع مستحق علي؟',
            answer: 'يمكنك التحقق من وجود أوامر دفع مستحقة من خلال قسم "طلبات الدفع" في البوابة. سيتم إشعارك تلقائيًا داخل النظام عند إصدار أي طلب دفع من قِبل المالك أو مدير ال'
          },
          {
            question: 'هل يمكنني تعديل مبلغ الطلب أو تاريخ الاستحقاق؟',
            answer: 'لا، لا يمكن تعديل بيانات طلب الدفع، حيث يتم تحديدها مسبقًا من قبل المالك أو مدير الصيانة.'
          },
          {
            question: 'ما هي طرق الدفع المتاحة؟',
            answer: 'الدفع يتم فقط إلكترونيًا عبر بوابة فني أعمال، ولا توجد طرق دفع أخرى حالياً.'
          },
          {
            question: 'كيف أعرف إذا تم استلام دفعي بنجاح؟',
            answer: 'ستتغير حالة الطلب تلقائيًا إلى "تم الدفع"، ويمكنك الرجوع لسجل الطلبات للتأكد.'
          }
        ]
      },
      {name: 'المحفظة',
        questions: [
          {
            question: 'ما هي وظيفة المحفظة في البوابة؟',
            answer: 'المحفظة تُمكِّنك من متابعة الرصيد المرتبط بحسابك واستخدامه في سداد الطلبات داخل النظام فقط.'
          },
          {
            question: 'هل يمكنني سحب أو تحويل الرصيد؟',
            answer: 'لا، لا يمكن سحب أو تحويل الرصيد لأي جهة أو طرف آخر، ويُستخدم فقط ضمن بوابة فني أعمال.'
          },
          {
            question: 'متى يتحدث الرصيد؟',
            answer: 'يتم تحديث الرصيد بشكل تلقائي بعد كل عملية دفع ناجحة أو إضافة رصيد.'
          }
        ]
      },
      {name: 'الإشعارات',
        questions: [
          {
            question: 'ما نوع الإشعارات التي أستلمها؟',
            answer: 'تستلم إشعارات مهمة فقط من مدير الصيانة في المنشأة أو من المالك، مثل طلبات الدفع أو الملاحظات المرتبطة بوحدتك.'
          },
          {
            question: 'هل يمكنني تخصيص أو تعطيل بعض الإشعارات؟',
            answer: 'لا، جميع الإشعارات مرتبطة بإدارة العقار ولا يمكن تعطيلها أو تخصيصها.'
          },
          {
            question: 'كيف أراجع التنبيهات السابقة؟',
            answer: 'يمكنك الدخول إلى مركز التنبيهات واستعراض السجل الكامل للرسائل السابقة حسب التاريخ.'
          }
        ]
      }
    ];

  return (
    <div>
            <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
            <PageMain>
              <div className="py-[32px]">
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <div className="relative rounded-[12px] bg-white p-[24px]">
                  {helpCenterData && Array.isArray(helpCenterData) && helpCenterData?.length > 0 
                  ? helpCenterData?.map((item,index)=><HelpCenterItem key={`helpCenterItem-${index}`} item={item} />)
                  :<div className="text-center font-bold text-blue text-[18px] cairo-font">لاتوجد اسئلة بعد.</div>}
                </div>
              </div>
            </PageMain>
    </div>
  );
};

export default HelpHomePage;
